import React from 'react';

/**
 * Catches render-time exceptions in the page tree so a single bad component
 * (e.g. an unexpected null on a freshly created campaign) shows a friendly
 * message and a reload button instead of a blank white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface in the console for debugging; the UI stays usable.
    // eslint-disable-next-line no-console
    console.error('Błąd renderowania strony:', error, info);
  }

  // Reset the error state when navigating to a different route.
  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.routeKey !== this.props.routeKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '48px 24px', textAlign: 'center', fontFamily: 'IBM Plex Sans, sans-serif' }}>
          <p style={{ fontSize: 15, fontWeight: 600, color: '#111827', marginBottom: 6 }}>
            Coś poszło nie tak podczas wyświetlania tej strony.
          </p>
          <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>
            Odśwież stronę. Jeśli problem się powtarza, skontaktuj się z nami.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              fontSize: 13, padding: '8px 16px', borderRadius: 8, border: 'none',
              background: '#1D4ED8', color: '#fff', cursor: 'pointer',
            }}
          >
            Odśwież stronę
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
